import React from 'react';
import BhimaStatCard from './widgets/BhimaStatCard';
import BhimaGoldChart from './widgets/BhimaGoldChart';
import BhimaChart from './widgets/BhimaChart';
import BhimaDonutTotalChart from './widgets/BhimaDonutTotalChart';
import StatCard from '../DashboardNew/widgets/StatCard';
import SimpleTable from '../DashboardNew/widgets/SimpleTable';
import PlaceholderChart from '../DashboardNew/widgets/PlaceholderChart';
import GroupRenderer from '../DashboardNew/widgets/GroupRenderer';
import StackRenderer from '../DashboardNew/widgets/StackRenderer';

const TextCard = ({ title, content }) => {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div>{content}</div>
        </div>
    );
};

// Placeholder for future types (chart, table, etc.)
const UnknownCard = ({ title }) => {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div>Unsupported section type</div>
        </div>
    );
};

export default function SectionRenderer({ section }) {
    const { type, title, content, component, props } = section;

    // Built-in types
    if (type === 'text') {
        return <TextCard title={title} content={content} />
    }


    // Render Tables
    if (type === 'table') {
        const tableProps = props || section;
        return <SimpleTable title={tableProps.title ?? title} columns={tableProps.columns} rows={tableProps.rows} />
    }

    // Render Groups (horizontal/vertical/grid layout)
    if (type === 'group') {
        return <GroupRenderer section={section} />
    }

    // Render Stacks (vertical stacking)
    if (type === 'stack') {
        return <StackRenderer section={section} />
    }

    // Custom component registry (by name)
    const registry = {
        BhimaStatCard,
        BhimaGoldChart,
        BhimaChart,
        BhimaDonutTotalChart,
        StatCard,
        SimpleTable,
        PlaceholderChart,
    };

    // Render Custom Components
    if (type === 'component' && component && registry[component]) {
        const Comp = registry[component];
        return <Comp {...(props || {})} />
    }

    return <UnknownCard title={title} />
}
